import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { FirebaseCredential } from '../models/firebase/FirebaseCredential';
import { FirebaseUser } from '../models/firebase/FirebaseUser';
import { environment } from 'src/environments/environment';
import { SnackbarService } from './snackbar.service';

var secondaryApp;

@Injectable({
  providedIn: 'root'
})
export class AppAuthService {
  constructor(private snack: SnackbarService, private fireAuth: AngularFireAuth) {
  }
  async signInWithCredential(credential: any) {
    await this.fireAuth.signInWithCredential(credential).then(resp => {
      // this.userService.updateUserID('test-ugur');
    });
  }

  async signInWithCredentials(username: string, password: string): Promise<FirebaseCredential> {
    try {
      const credential = await this.fireAuth.signInWithEmailAndPassword(username, password);
      const fireUser: FirebaseUser = {
        email: credential.user.email,
        emailVerified: credential.user.emailVerified,
        isAnonymous: credential.user.isAnonymous,
        phoneNumber: credential.user.phoneNumber,
        photoURL: credential.user.photoURL,
        refreshToken: credential.user.refreshToken,
        uid: credential.user.uid
      }
      const fireCredential: FirebaseCredential = {
        user: fireUser
      }

      return Promise.resolve(fireCredential);
    } catch (err) {
      this.snack.openSnackBar(err.message);
      throw err;
    }
  }

  async createUserEmailAndPassword(username: string, password: string): Promise<FirebaseCredential> {
    try {
      const config = environment.firebase;
      
      if(!secondaryApp) {
        secondaryApp = firebase.default.initializeApp(config, "Secondary");
      }

      const credential = await secondaryApp.auth().createUserWithEmailAndPassword(username, password);

      const fireUser: FirebaseUser = {
        email: credential.user.email,
        emailVerified: credential.user.emailVerified,
        isAnonymous: credential.user.isAnonymous,
        phoneNumber: credential.user.phoneNumber,
        photoURL: credential.user.photoURL,
        refreshToken: credential.user.refreshToken,
        uid: credential.user.uid
      }
      const fireCredential: FirebaseCredential = {
        user: fireUser
      }
      secondaryApp.auth().signOut();
      return Promise.resolve(fireCredential);
    } catch (err) {
      this.snack.openSnackBar(err.message);
      throw err;
    }
  }

  async changePassword(newPassword: string): Promise<boolean> {
    try {
      (await this.fireAuth.currentUser).updatePassword(newPassword);
      return Promise.resolve(true);
    } catch (err) {
      this.snack.openSnackBar(err.message);
      throw err;
    }
  }

  async signOut() {
    await this.fireAuth.signOut();
  }

  async loadCurrentUser(): Promise<any> {
    const currentUser = await this.fireAuth.currentUser;

    const fireUser: FirebaseUser = {
      email: currentUser.email,
      emailVerified: currentUser.emailVerified,
      isAnonymous: currentUser.isAnonymous,
      phoneNumber: currentUser.phoneNumber,
      photoURL: currentUser.photoURL,
      refreshToken: currentUser.refreshToken,
      uid: currentUser.uid
    }
    const fireCredential: FirebaseCredential = {
      user: fireUser
    }

    return Promise.resolve(fireCredential);
  }
}
